function getTrackingUrl(carrier, trackNo, postalCode = "") {
    if (!carrier || !trackNo) {
        return "";
    }

    let link = "";
    let carrierCode = carrier.includes("-")
        ? carrier.split("-")[0].toUpperCase()
        : carrier.toUpperCase();

    switch (carrierCode) {
        case "DHL":
            link = `https://www.dhl.de/de/privatkunden/pakete-empfangen/verfolgen.html?piececode=${trackNo}`;
            break;
        case "DPD":
            link = `https://tracking.dpd.de/status/de_DE/parcel/${trackNo}`;
            break;
        case "STANDARD":
        case "GLS":
            link = `https://www.gls-pakete.de/reach-sendungsverfolgung?match=${trackNo}&trackingNumber=${trackNo}&postCode=${postalCode}`;
            break;
        case "HERMES":
            link = `https://www.myhermes.de/empfangen/sendungsverfolgung/sendungsinformation/#${trackNo}`;
            break;
        case "UPS":
            link = `https://wwwapps.ups.com/WebTracking/track?loc=de_DE&track=yes&trackNums=${trackNo}`;
            break;
        case "POST DE":
            link = `https://www.deutschepost.de/sendung/simpleQueryResult.html?form.sendungsnummer=${trackNo}`;
            break;
        case "EXPORTO":
            link = `https://www.post.ch/swisspost-tracking?formattedParcelCodes=${trackNo}`;
            break;
        case "RABEN":
            link = `https://myraben.com/link/doc?shipment=${trackNo}&param1=FDIVJ8atiYqEv5MKc8&param2=KSLbIXZz9paWNm53aI`;
            break;
        case "DACHSER":
        case "SONST":
        case "SPE":
            link = `https://elogistics.dachser.com/shp2s/?search=${trackNo}`;
            break;
    }

    return link.trim();
}

window.getTrackingUrl = getTrackingUrl;

function formatNumber(type, value) {
    if (value == null) {
        return "n/a";
    }

    if (type === "myExport") {
        return value;
    }

    if (type === "display" || type === "filter") {
        return DataTable.render.number().display(value);
    }

    return value;
}

window.formatNumber = formatNumber;

function formatCurrency(type, value) {
    if (value == null) {
        return "n/a";
    }

    if (type === "myExport") {
        return value;
    }

    if (type === "display" || type === "filter") {
        return DataTable.render.number(null, null, 2, "", " €").display(value);
    }

    return value;
}

window.formatCurrency = formatCurrency;

function formatIcon(type, value, condition, icon, icon2) {
    if (type === "myExport") {
        return value === condition ? "Y" : "N";
    }

    if (value === condition) {
        return '<i class="h-4 w-4 fa-solid ' + icon + '"></i>';
    }

    if (icon2 !== null) {
        return '<i class="h-4 w-4 fa-solid ' + icon2 + '"></i>';
    }

    return "n/a";
}

window.formatIcon = formatIcon;

function formatDate(type, date) {
    if (!date) {
        return "";
    }

    let dt;
    if (date instanceof Date) {
        dt = DateTime.fromJSDate(date);
    } else {
        dt = DateTime.fromSQL(date);
        if (!dt.isValid) {
            dt = DateTime.fromISO(date);
        }
        if (!dt.isValid) {
            dt = DateTime.fromJSDate(new Date(date));
        }
    }

    if (!dt || !dt.isValid) {
        return "";
    }

    if (type === "myExport" || type === "display" || type === "filter") {
        return dt.toFormat("dd.MM.yyyy");
    }

    return dt.toMillis();
}

window.formatDate = formatDate;

// Funktion, um zu prüfen, ob alle required-Felder gefüllt sind
function checkRequiredFields() {
    // Variable, um zu tracken, ob alle Felder korrekt gefüllt sind
    let allFieldsFilled = true;

    // Alle input-Felder mit required-Attribut selektieren
    const requiredFields = document.querySelectorAll("input[required]");

    // Überprüfung jedes Feldes
    requiredFields.forEach((field) => {
        // Wenn ein Feld leer ist, setze allFieldsFilled auf false
        if (field.value.trim() === "") {
            allFieldsFilled = false;
            field.parentNode.classList.add("border-red-500");
            // Fehlermeldung oder Hinweis für den Benutzer anzeigen
            const errorElement =
                field.parentNode.parentNode.querySelector(".error");
            if (errorElement) {
                errorElement.classList.remove("hidden");
            }
        } else {
            field.parentNode.classList.remove("border-red-500");
            // Fehlermeldung oder Hinweis für den Benutzer verstecken
            const errorElement =
                field.parentNode.parentNode.querySelector(".error");
            if (errorElement) {
                errorElement.classList.add("hidden");
            }
        }
    });

    return allFieldsFilled;
}

window.checkRequiredFields = checkRequiredFields;
